export default __webpack_public_path__ + "static/media/Screenshot-react-weather.a842cd2d.png";